<template>
    <div>
        <FullscreenLoading v-if="isLoading" />

        <div class="row mt-3">
            <div class="col-12">
                <div class="card">
                    <div class="card-header pb-3">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <span class="h4">{{ $t('welcome_signs.title') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <table class="table table-sm table-no-side-paddings table-striped" style="table-layout: fixed">
                            <thead>
                                <tr>
                                    <th style="width: 190px">{{ $t('welcome_signs.current_image') }}</th>
                                    <Ordering @change="loadWelcomeSigns()" v-model="order" field="name" tag="th">
                                        {{ $t('welcome_signs.sign_name') }}
                                    </Ordering>
                                    <th>{{ $t('welcome_signs.current_text') }}</th>
                                    <th v-if="store.state.companySettings.welcome_sign_music_enabled">{{ $t('welcome_signs.current_music') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td />

                                    <td>
                                        <input
                                            :placeholder="$t('welcome_signs.sign_name')"
                                            @change="loadWelcomeSigns(1)"
                                            class="form-control form-control-filtering"
                                            type="text"
                                            v-model="filtering.name"
                                        />
                                    </td>

                                    <td>
                                        <input
                                            :placeholder="$t('welcome_signs.current_text')"
                                            @change="loadWelcomeSigns(1)"
                                            class="form-control form-control-filtering"
                                            type="text"
                                            v-model="filtering.text"
                                        />
                                    </td>

                                    <td v-if="store.state.companySettings.welcome_sign_music_enabled"/>
                                </tr>

                                <tr v-for="welcomeSign of welcomeSigns.data" :key="welcomeSign.id">
                                    <td>
                                        <a v-if="welcomeSign.current_image_url" :href="welcomeSign.current_image_url" target="_blank">
                                            <img
                                                :key="welcomeSign.id + '_' + welcomeSign.updated_at + '_' + (welcomeSign.active?.updated_at ?? '?')"
                                                :src="welcomeSign.current_image_url"
                                                :style="getPreviewStyle(welcomeSign)"
                                            />
                                        </a>
                                        <span v-else>{{ $t('welcome_signs.no_preview_available') }}</span>
                                    </td>

                                    <td>{{ welcomeSign.name }}</td>
                                    <td>{{ welcomeSign.active_content?.text ?? '-' }}</td>

                                    <td v-if="store.state.companySettings.welcome_sign_music_enabled">
                                        <div v-if="welcomeSign.active_content?.songs?.length">
                                            <div v-for="(song, index) of welcomeSign.active_content.songs" :key="index" class="mb-4">
                                                <div class="d-flex align-items-center mb-1">
                                                    <img
                                                        style="width: 25px; height: 25px;"
                                                        :src="song.cover ? `/api/songs/${song.id}/cover?token=${store.state.token}` : '/images/audio.png'"
                                                        class="avatar rounded-circle mr-2"
                                                    />
                                                    <span>{{ song.display_name }} - {{ song.author }}</span>
                                                </div>
                                                <SongPlayer
                                                    :preload="'none'"
                                                    :src="`/storage/songs/${song.name}`"
                                                    :key="'song_' + song.id"
                                                />
                                            </div>
                                        </div>
                                        <div v-else>
                                            -
                                        </div>
                                    </td>
                                </tr>

                                <tr v-if="welcomeSigns.data.length === 0 && !isLoading">
                                    <td colspan="4" class="no-results">
                                        {{ $t('welcome_signs.no_welcome_signs_found') }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="card-footer border-0">
                        <Pagination :pagination="welcomeSigns" @change="loadWelcomeSigns" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
    import Pagination from '../../components/Pagination.vue';
    import FullscreenLoading from '../../components/FullscreenLoading.vue';
    import Ordering from '../../components/Ordering.vue';
    import { inject, onMounted, ref } from 'vue';
    import filteringFromObject from '../../utils/filteringFromObject.js';
    import Axios from 'axios';
    import { notifyError } from '../../utils/notify.js';
    import SongPlayer from '../../components/SongPlayer.vue';
    import { getPreviewStyle } from '../../utils/welcomeSign.js';

    const store = inject('store');

    const isLoading = ref(false);

    const order = ref('id,desc');
    const filtering = ref({});

    const welcomeSigns = ref({
        data: [],
        current_page: 1,
    });

    onMounted(() => {
        loadWelcomeSigns();
    });

    async function loadWelcomeSigns(page = undefined) {
        isLoading.value = true;

        try {
            const response = await Axios.get('/api/welcome-signs', {
                params: {
                    page: page || welcomeSigns.value.current_page,
                    order: order.value,
                    filters: filteringFromObject(filtering.value),
                },
            });

            welcomeSigns.value = response.data;
        } catch (exception) {
            notifyError(exception);
        }

        isLoading.value = false;
    }
</script>
